import { isUrl } from "utils";
import asyncComponent from "../components/AsyncComponent/AsyncComponent";

const Home = asyncComponent(() => import("views/Home/Home"));
// const TestPage = asyncComponent(() => import("views/TestPage"));
const Forms = asyncComponent(() => import("views/Forms/Forms"));
const AnimationPage = asyncComponent(() => import("views/Animation"));
const RetailDetail = asyncComponent(() => import("views/Retail/Detail"));
const RetailThankU = asyncComponent(() => import("views/Retail/ThankU"));
const RetailWalletThankU = asyncComponent(
  () => import("views/Retail/ThankUforWallet")
);
const RetailBankInfo = asyncComponent(() => import("views/Retail/BankInfo"));
const RetailWalletInfo = asyncComponent(
  () => import("views/Retail/WalletInfo")
);
const RetailAgreement = asyncComponent(
  () => import("views/Retail/IndividualAgreement")
);
const CommercialEntityDetail = asyncComponent(
  () => import("views/Commercial/EntityDetail")
);
const CommercialOwnerShip = asyncComponent(
  () => import("views/Commercial/BeneficialOwnership")
);
const CommercialAgreement = asyncComponent(
  () => import("views/Commercial/CommercialAgreement")
);
const CommercialThankU = asyncComponent(
  () => import("views/Commercial/ThankU")
);
const CommercialBankInfo = asyncComponent(
  () => import("views/Commercial/BankInfo")
);
const CommercialWalletInfo = asyncComponent(
  () => import("views/Commercial/WalletInfo")
);

const SUB_FOLDER = process.env.REACT_APP_SUB_FOLDER
  ? process.env.REACT_APP_SUB_FOLDER
  : "";

const BASE_FOLDER = `${SUB_FOLDER}/:locale(en|cn|tc|jp)/`;

interface RouterObject {
  path: string;
  authority: Boolean;
  layout: number;
  children?: Array<RouterObject>;
}

interface MenuObject {
  name: string;
  path: string;
  key: string;
  authority: Boolean;
  children?: Array<MenuObject>;
  exact?: Boolean;
  disable?: Boolean;
}

const appRouterData = [
  { path: "", component: Home, layout: 1, authority: false, exact: true },
  {
    path: ":locale(en|cn|tc|jp)",
    component: Home,
    layout: 1,
    authority: false,
    exact: true,
  },
  // {
  //   path: "retail/detail",
  //   component: RetailDetail,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  // {
  //   path: "retail/agreement",
  //   component: RetailAgreement,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  {
    path: "retail/ThankU",
    component: RetailThankU,
    layout: 1,
    authority: false,
    exact: true,
  },
  {
    path: "retail/WalletThankU",
    component: RetailWalletThankU,
    layout: 1,
    authority: false,
    exact: true,
  },
  // {
  //   path: "retail/bankInfo",
  //   component: RetailBankInfo,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  {
    path: "retail/WalletInfo",
    component: RetailWalletInfo,
    layout: 1,
    authority: false,
    exact: true,
  },
  // {
  //   path: "commercial/entityDetail",
  //   component: CommercialEntityDetail,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  // {
  //   path: "commercial/ownerShip",
  //   component: CommercialOwnerShip,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  // {
  //   path: "commercial/agreement",
  //   component: CommercialAgreement,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  {
    path: "commercial/ThankU",
    component: CommercialThankU,
    layout: 1,
    authority: false,
    exact: true,
  },
  // {
  //   path: "commercial/bankinfo",
  //   component: CommercialBankInfo,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  // {
  //   path: "commercial/WalletInfo",
  //   component: CommercialWalletInfo,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  // {
  //   path: "forms",
  //   component: Forms,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  // {
  //   path: "test",
  //   component: TestPage,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
  // {
  //   path: "animation",
  //   component: AnimationPage,
  //   layout: 1,
  //   authority: false,
  //   exact: true,
  // },
];

const menuData = [
  {
    name: "Home",
    path: "",
    key: "appHome",
    img: "icon_home",
    authority: false,
    exact: true,
  },
  // {
  //   name: "Detail",
  //   path: "retail/detail",
  //   key: "retailDetail",
  //   img: "icon_form",
  //   authority: false,
  //   disable: true,
  // },
  {
    name: "Application Completed",
    path: "",
    key: "retailFinish",
    img: "icon_finish",
    authority: false,
    disable: true,
  },
];

const menuCommercialData = [
  {
    name: "Home",
    path: "",
    key: "appHome",
    img: "icon_home",
    authority: false,
    exact: true,
  },
  {
    name: "Entity Detail",
    path: "commercial/entityDetail",
    key: "commercialEntityDetail",
    img: "icon_form",
    authority: false,
    disable: true,
  },
  {
    name: "Beneficial Ownership",
    path: "commercial/ownerShip",
    key: "commercialOwnerShip",
    img: "icon_form_company",
    authority: false,
    disable: true,
  },
  {
    name: "Application Completed",
    path: "commercial/finish",
    key: "commercialFinish",
    img: "icon_finish",
    authority: false,
    disable: true,
  },
];

export const appRouters = () =>
  routerFormatter(appRouterData, BASE_FOLDER, false);

export const appMenu = (locale, type) =>
  menuFormatter(
    type === 1 ? menuCommercialData : menuData,
    `${SUB_FOLDER}/${locale}/`,
    false,
    ""
  );

const routerFormatter = (
  data: Array<RouterObject>,
  parentPath: string = BASE_FOLDER,
  parentAurhority: Boolean
) => {
  return data.map((item) => {
    let { path } = item;
    path = parentPath + item.path;
    const result = {
      ...item,
      path,
      authority: item.authority || parentAurhority,
    };
    if (item.children) {
      result.children = routerFormatter(
        item.children,
        `${parentPath}${item.path}/`,
        item.authority
      );
    }
    return result;
  });
};

function menuFormatter(
  data: Array<MenuObject>,
  parentPath: string = SUB_FOLDER,
  parentAuthority: Boolean,
  parentKey = ""
) {
  return data.map((item) => {
    let { path, key, disable } = item;
    if (path && !isUrl(path)) {
      path = parentPath + item.path;
    }
    if (parentKey) {
      key = parentKey + "_" + key;
    }
    const result = {
      ...item,
      path,
      disable,
      key,
      authority: item.authority || parentAuthority,
    };
    if (item.children) {
      result.children = menuFormatter(
        item.children,
        `${parentPath}${item.path}/`,
        item.authority,
        item.key
      );
    }
    return result;
  });
}
